import { businessDetailsSectionValidationMap } from './sections/businessDetails/validations';
import { factoringNeedSectionValidationMap } from './sections/factoringNeed/validations';

export const cbBankFinancingNeedFieldValidation = {
  ...businessDetailsSectionValidationMap,
  ...factoringNeedSectionValidationMap,
};
